import React, { useState } from "react";
import MessageSummary from "./MessageSummary";
import { useEffect } from "react";
import { useJobProvider } from "../../../../Providers/Vendor/Jobs";
import moment from "moment";
import { useTimesheetProvider } from "../../../../Providers/Vendor/Timesheet";
import Daywise from "./DashboardCards/Timesheet/Daywise";
import Back from "../../../../Components/Back";
import { useConnectionProvider } from "../../../../Providers/Vendor/Connections";
import { stringAvatar } from "../../../../Utils/avatar";
import api from "../../../../Utils/api";
import Swal from "sweetalert2";
import { Modal, Select, Space } from "antd";
import { Avatar } from "@mui/material";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useProjectProvider } from "../../../../Providers/Vendor/Project";
import { useCountryStateCityProvider } from "../../../../Providers/Common/CountyStateCity";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../../Utils/constants";

export default function OngoingJobInformation({ reset }) {
  const [job, setJob] = useState({});
  const [showTimesheetDetails, setShowTimesheetDetails] = useState(false);
  const { fetchJobDetails } = useJobProvider();
  const { selectedTimesheet } = useTimesheetProvider();
  const { clients, fetchCurrentClients, fetchVendors, vendors } =
    useConnectionProvider();
  const { fetchProjects, projects } = useProjectProvider();
  const permissions = useSelector((state) => state.user.permissions);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openProject, setOpenProject] = useState(false);
  const [category, setCategory] = useState(null);
  const [ownerId, setOwnerId] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasTimesheets, setHasTimesheets] = useState(false);
  const { id } = useParams();

  const showModal = () => setOpen(true);
  const handleCancel = () => setOpen(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname;

  const { getCountries, getStatesByCountry, state, country } =
    useCountryStateCityProvider();

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleOkProject = async () => {
    const res = await api.post("/jobnproject/assignproject", {
      userId: localStorage.getItem("userId"),
      job_id: id,
      project_id: job?.project?.id,
      assignProject_id: projectId,
    });

    if (res.data.success) {
      Swal.fire("Successfully Assigned!", res.data.msg, "success").then(() => {
        setOpen(false);
      });
    } else {
      Swal.fire("Error in Assigning !", res.data.msg, "error").then(() =>
        setOpen(false)
      );
    }
  };

  const handleCancelProject = () => {
    setOpenProject(false);
  };

  const handleOk = async () => {
    setLoading(true);
    if (ownerId && job) {
      const res = await api.post("/jobnproject/changeOwner", {
        userId: localStorage.getItem("userId"),
        transferUserId: ownerId,
        job_id: job.id,
      });

      if (res.data.success) {
        Swal.fire("Successfully Assigned!", res.data.msg, "success").then(
          () => {
            setOpen(false);
          }
        );
      } else {
        Swal.fire("Error in Assigning !", res.data.msg, "error").then(() =>
          setOpen(false)
        );
      }
    }
  };
  useEffect(() => {
    fetchJobDetails(id).then((data) => {
      setJob(data);
    });
    fetchCurrentClients();
    fetchVendors();
  }, []);

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    getCountries(job?.country);
    getStatesByCountry(job?.country, job?.state);
  }, [job?.country, job?.state]);

  return !showTimesheetDetails &&
    (selectedTimesheet === null || job.id === id) ? (
    <div>
      <div className="bg-white rounded-lg p-4 pr-10 font-[Roboto]">
        <Back
          onClick={() => {
            navigate(from ? from : "/dashboard/jobscard");
          }}
        />
        <div className="flex justify-between py-2">
          <span className="flex">
            <span className="block w-28 font-medium">Title:</span>
            <span className="ml-4">{job?.name}</span>
          </span>
          <span className="flex">
            <span className="block w-28 font-medium">Start Date:</span>
            <span className="font-medium">
              <span className="font-normal">
                {job?.start_date
                  ? moment
                    .utc(job.start_date, "YYYY-MM-DD")
                    .format("DD/MM/YYYY")
                  : null}
              </span>
            </span>
          </span>
        </div>

        <div className="flex py-2">
          <span className="block w-24 mr-8 font-medium">Description:</span>
          <div className="flex flex-col space-y-1">
            <div className="text-justify">
              {isExpanded
                ? job?.description?.split(" ")?.join(" ")
                : job?.description?.split(" ")?.slice(0, 70)?.join(" ")}
            </div>
            {job?.description?.split(" ").length >= 70 && (
              <div className="flex flex-row justify-start">
                <button
                  type="button"
                  className="text-blue-400"
                  onClick={toggleExpand}
                >
                  {isExpanded ? "See Less" : "See More"}
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center py-2">
          <span className="block w-28 font-medium">Skills:</span>
          <div className="flex ml-4">
            <span className="space-x-3">
              {job?.main_skill?.map((skill) => {
                return (
                  <span className="text-justify text-sm py-0.5 px-1 text-[#139588] w-[83px] h-[25px] border-[1px] border-[#139588]">
                    {skill}
                  </span>
                );
              })}
              {!job?.main_skill && "No Skills Provided"}
            </span>
          </div>
        </div>

        <div className="flex py-2">
          <span className="flex">
            <span className="block w-28 font-medium">Location:</span>
            <span className="ml-4">{job?.location}</span>
          </span>
        </div>

        {(Object.keys(job).length === 0 && job.constructor === Object) ||
          job?.location === "REMOTE" ? (
          <></>
        ) : (
          <div className="mr-4 flex flex-row justify-between">
            <span className="font-medium">
              Country:{" "}
              <span className="font-normal ml-16">
                {Object.keys(country).length === 0 &&
                  country.constructor === Object
                  ? "No Country Provided"
                  : country}
              </span>
            </span>
            <span className="font-medium">
              State:{" "}
              <span className="font-normal ml-2">
                {Object.keys(state).length === 0 && state.constructor === Object
                  ? "No State Provided"
                  : state}
              </span>
            </span>
            <span className="font-medium">
              City:{" "}
              <span className="font-normal ml-2">
                {job?.city || "No City Provided"}
              </span>
            </span>
          </div>
        )}

        <div className="flex items-center py-2">
          <span className="block w-28 mr-4 font-medium">Client:</span>
          <div className="flex items-end">
            <span className="flex items-center px-2 py-2 mr-4 space-x-4 w-[250px] border border-[#BDBDBD] rounded-[10px]">
              <Link
                target="_blank"
                to={
                  `/${job?.owner?.role?.toLowerCase()}/profile/` +
                  job?.owner?.id
                }
              >
                <Avatar
                  style={{ width: "30px", height: "30px" }}
                  className="cursor-pointer"
                  {...stringAvatar(
                    `${job?.owner?.firstName ?? ""} ${job?.owner?.lastName ?? ""
                    }`
                  )}
                  src={job?.owner?.profilePhoto}
                />
              </Link>
              <span>{job?.owner?.company || job?.owner?.firstName}</span>
            </span>
            <div className="flex flex-row h-[60px] justify-between items-end">
              {job?.owner?.id === localStorage.getItem("userId") && (
                <span
                  onClick={showModal}
                  className="text-sm text-[#02A4EF] underline cursor-pointer"
                >
                  change
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center py-2">
          <span className="block w-28 mr-4 font-medium">Project:</span>
          <div className="flex items-end">
            <span className="flex items-center px-2 py-2 mr-4 border border-[#BDBDBD] rounded-[10px]">
              <span className="w-[30px] h-[30px] mr-[20px] bg-[#2EBAA3] text-white flex justify-center items-center rounded-lg">
                P
              </span>
              <span className="text-gray-700 font-medium">
                {job?.project?.title ? job?.project?.title : "Default Project"}
              </span>
            </span>
            {permissions?.includes(`admin-client`) ||
              permissions?.includes(`admin-vendor`) ||
              permissions?.includes(userPermissions.job.edit) ? (
              <span
                onClick={() => {
                  setOpenProject(true);
                }}
                className="text-sm text-[#02A4EF] underline cursor-pointer"
              >
                change
              </span>
            ) : null}
          </div>
        </div>

        <div className="flex justify-between py-2">
          <div className="flex items-center">
            <span className="block w-28 mr-4 font-medium">Consultant:</span>
            <div
              className={`flex flex-row py-2 mr-4 text-white w-[250px] rounded-[10px] px-4 items-center gap-x-3 bg-[#2EBAA3] `}
            >
              {job?.consultant?.firstName ? (
                <>
                  <Link
                    target="_blank"
                    to={`/consultant/profile/` + job?.consultant?.id}
                  >
                    <Avatar
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "20px",
                      }}
                      className="cursor-pointer"
                      {...stringAvatar(
                        `${job?.consultant?.firstName ?? ""} ${job?.consultant?.lastName ?? ""
                        }`
                      )}
                      src={job?.consultant?.profilePhoto}
                    />
                  </Link>
                  <span>
                    {job?.consultant?.firstName} {job?.consultant?.lastName}
                  </span>
                </>
              ) : (
                <span className="flex items-center justify-center">
                  No Consultant Assigned Yet
                </span>
              )}
            </div>
          </div>
          <div className="flex items-center">
            <span className="block w-28 mr-4 font-medium">Vendor:</span>
            <div
              className={`flex flex-row py-2 mr-4 text-black w-[250px] rounded-[10px] px-4 items-center gap-x-3 bg-[#CFCFCF] `}
            >
              {job?.child?.firstName ? (
                <>
                  <Link
                    target="_blank"
                    to={`/vendor/profile/` + job?.child?.id}
                  >
                    <Avatar
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "20px",
                      }}
                      className="cursor-pointer"
                      {...stringAvatar(`${job?.child?.company ?? ""}`)}
                      src={job?.child?.profilePhoto}
                    />
                  </Link>
                  <span>{job?.child?.company}</span>
                </>
              ) : (
                <span className="flex items-center justify-center">
                  No Vendor Assigned Yet
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        title={<span className="text-xl font-semibold">Change Job Owner</span>}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <button
            className="text-white hover:font-medium"
            style={{
              width: "200px",
              height: "45px",
              background: "#139588",
              borderRadius: "4px",
            }}
            loading={loading}
            onClick={handleOk}
          >
            Save Changes
          </button>,
        ]}
      >
        <p className="mt-6">Select Category</p>
        <Space wrap>
          <Select
            defaultValue="Select"
            showSearch
            style={{ width: 470 }}
            listHeight={128}
            value={category}
            onChange={setCategory}
            options={[
              { value: "Client", label: "Client" },
              { value: "Vendor", label: "Vendor" },
            ]}
          />
        </Space>
        <p className="mt-3">Job Owner Details</p>
        <Space wrap>
          <Select
            defaultValue="Select Owner"
            showSearch
            style={{ width: 470 }}
            listHeight={128}
            value={ownerId}
            onChange={setOwnerId}
            options={
              category === "Client"
                ? clients
                  .filter((client) => client.status === "Current")
                  .map((client) => ({
                    value: client.id,
                    label: `${client.companyName}`,
                  }))
                : category === "Vendor" &&
                vendors
                  .filter((client) => client.status === "Current")
                  .map((vendor) => ({
                    value: vendor.vendor_id,
                    label: `${vendor.companyName}`,
                  }))
            }
          />
        </Space>
      </Modal>
      <Modal
        open={openProject}
        title={<span className="text-xl font-semibold">Change Project</span>}
        onOk={handleOkProject}
        onCancel={handleCancelProject}
        footer={[
          <button
            className="text-white hover:font-medium"
            style={{
              width: "200px",
              height: "45px",
              background: "#139588",
              borderRadius: "4px",
            }}
            loading={loading}
            onClick={handleOkProject}
          >
            Save Changes
          </button>,
        ]}
      >
        <p className="mt-3">Select Project</p>
        <Space wrap>
          <Select
            defaultValue="Select Project"
            showSearch
            style={{ width: 470 }}
            listHeight={128}
            value={projectId}
            onChange={setProjectId}
            options={projects
              .map((project) => ({
                value: project.id,
                label: `${project.title}`,
              }))
              .concat([{ value: null, label: "Default Project" }])}
          />
        </Space>
      </Modal>
      <div className="mt-4">
        {permissions?.includes(`admin-vendor`) ||
          permissions?.includes(userPermissions.job.timesheetAction) ? (
          <MessageSummary
            consultant={job?.consultant}
            vendor={job?.vendor}
            id={id}
            setShowTimesheetDetails={setShowTimesheetDetails}
            setHasTimesheets={setHasTimesheets}
          />
        ) : null}
      </div>
    </div>
  ) : (
    <Daywise
      showDatePicker
      hideJobInfo={true}
      setShowTimesheetDetails={setShowTimesheetDetails}
      job={{ id: id, startDate: job?.job?.start_date }}
    />
  );
}
